import request from '@/utils/request'

export function goUserInfo(params) {
  return request({
    url: '/api/user/userInfo',
    method: 'get',
    params
  })
}

export function goUser(params) {
  return request({
    url: '/cellStorage/selList',
    method: 'get',
    params
  })
}

export function goUserList(params) {
  return request({
    url: '/cellStorage/selList',
    method: 'get',
    params
  })
}


export function postkh(params) {
  return request({
    url: '/make/makeVisit',
    method: 'get',
    params
  })
}


// /cellStorage/selList?keyWord=11



// WEBPACK FOOTER //
// ./src/api/user.js